import { render, staticRenderFns } from "./MatterCard.vue?vue&type=template&id=7c011fc4&scoped=true"
import script from "./MatterCard.vue?vue&type=script&lang=js"
export * from "./MatterCard.vue?vue&type=script&lang=js"
import style0 from "./MatterCard.vue?vue&type=style&index=0&id=7c011fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c011fc4",
  null
  
)

export default component.exports